/**
 * Fire an event which is listed to by molecules/slider/_pagination.antlers.html
 * 
 * @param {*} swiper 
 */
function setCaption(swiper) {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const caption = currentSlide.dataset.caption
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent('new-slide-displayed',
            { detail: caption }));
    }, 0);
}

/**
 * Start playing the video when it's the current slide.
 * 
 * // TODO: Maybe check for this a little earlier, so we can start playing
 * the video already when sliding to it.
 * 
 * @param {*} swiper 
 */
function playIfVideo(swiper) {

    try {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const isVideo = currentSlide.dataset.video

        setTimeout(() => {
            if (isVideo) {
                const video = currentSlide.querySelector('video')
                video.dispatchEvent(new CustomEvent('slide-is-video'));
            }
        }, 1000);
    } catch (error) {
        console.warn('SliderHelpers.js #36, Problem reading slide.');
    }
}

/**
 * Stop playing all videos when changing to next slide.
 * 
 * @param {*} sliderClass 
 */
function pauseVideos(sliderClass) {
    const swiperContainer = document.querySelector(sliderClass);
    const allVideos = swiperContainer.querySelectorAll('video')

    allVideos.forEach(video => {
        video.dispatchEvent(new CustomEvent('slider-pause-video'));
    });
}

export { setCaption, playIfVideo, pauseVideos }